export var SearchDataSource;
(function (SearchDataSource) {
    SearchDataSource["COMMERCETOOLS"] = "commercetools";
    SearchDataSource["BLOOMREACH"] = "bloomreach";
})(SearchDataSource || (SearchDataSource = {}));
